/**
 * Focus holds at most this many open tasks a day (CER-135); the database
 * enforces it (private.focus_limit) and refuses a fourth with hint
 * focus_full, which the apps answer by asking which one makes room.
 */
export const FOCUS_LIMIT = 3;

/** Whether an error is the database refusing a task into a full day's focus. */
export function isFocusFull(error: unknown): boolean {
  return typeof error === 'object' && error !== null && (error as { hint?: unknown }).hint === 'focus_full';
}
